import * as React from 'react';
import styled, { css } from 'styled-components';

import { color, media, variants } from 'styles/utils';
import { PAGE_REGIONS, getPageRegionProps } from 'utils';

import Icon from 'components/Icon';
import Link from 'components/Link';
import VisuallyHidden from 'components/VisuallyHidden';

import Logo from 'images/sleuth-logo.svg?svgr';

import Navbar from './Navbar';

const StyledLogo = styled(Logo)`
  color: inherit;
  fill: currentColor;
  height: 2rem;
  width: auto;

  ${variants({
    primary: css`
      ${media.min('md')} {
        height: 2.5rem;
      }
    `,
    secondary: css`
      color: ${color('teal')};
      opacity: 0;
      transform: translateY(25%);
      transition: 150ms cubic-bezier(0.5, 0, 0.5, 1);
      transition-property: opacity, transform;

      [data-sticky]:not([data-static]) & {
        opacity: 1;
        transform: translateY(0);
      }
    `,
  })}
`;

export default function Header({ inset, menus }) {
  return (
    <>
      {menus.primary && (
        <Navbar
          {...getPageRegionProps(PAGE_REGIONS.topnav)}
          as="header"
          id="primary-navbar"
          inset={inset && !menus.secondary}
          modal
          sticky={!menus.secondary}
          variant="primary"
        >
          <Navbar.Brand as={Link} to="/">
            <VisuallyHidden>Home page</VisuallyHidden>
            <StyledLogo aria-hidden="true" variant="primary" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-label={`Toggle ${menus.primary.label} navigation`}
          >
            {({ isExpanded }) => (
              <Icon name={isExpanded ? 'close' : 'hamburger'} />
            )}
          </Navbar.Toggle>
          <Navbar.Menu variant="primary" menu={menus.primary} />
        </Navbar>
      )}
      {menus.secondary && (
        <Navbar id="secondary-navbar" inset={inset} sticky variant="secondary">
          <Navbar.Brand as={Link} to="/">
            <VisuallyHidden>Home page</VisuallyHidden>
            <StyledLogo aria-hidden="true" variant="secondary" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-label={`Toggle ${menus.primary.label} navigation`}
          >
            {({ isExpanded }) => (
              <strong>
                All content &ensp;
                <Icon
                  color="teal"
                  name={isExpanded ? 'chevron-up' : 'chevron-down'}
                  size="sm"
                />
              </strong>
            )}
          </Navbar.Toggle>
          <Navbar.Menu variant="secondary" menu={menus.secondary} />
        </Navbar>
      )}
    </>
  );
}
